var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGradientBackground5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 800 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    cx: 518.593,
    cy: 317.751,
    r: 649.942,
    id: "gradient-1",
    gradientTransform: "matrix(1.604582, -0.125374, 0.077898, 0.996961, -338.284079, 65.983691)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(146, 30, 195)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(51, 13, 92)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    cx: 600.191,
    cy: 104.857,
    r: 625.242,
    id: "gradient-2",
    gradientTransform: "matrix(2.178735, -0.425735, 0.191778, 0.981439, -600.516312, 205.5961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(146, 30, 195)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgba(51, 13, 92, 1)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    cx: 96.391,
    cy: 340.12,
    r: 466.076,
    id: "gradient-0",
    gradientTransform: "matrix(1.320111, -0.789315, 0.51318, 0.858281, -180.695122, 213.818741)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(214, 45, 220)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#758d29"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M -145.329 -142.377 C -37.976 -229.21 785.721 -119.553 966.378 -52.353 C 1071.094 -13.401 1106.213 318.274 937.237 363.15 C 889.809 375.746 675.526 296.767 545.309 289.445 C 347.182 278.305 290.55 388.142 46.009 324.299 C -124.871 279.687 -392.569 57.604 -145.329 -142.377 Z",
    style: {
      stroke: "rgb(129, 151, 57)",
      strokeWidth: 0,
      fillOpacity: 0.95,
      fill: "url(#gradient-1)"
    },
    stroke: "rgb(255,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -50.195 -237.318 C 175.133 -352.906 834.233 -370.441 983.959 -189.717 C 1154.984 16.716 1037.759 72.605 834.241 139.514 C 718.062 177.71 633.264 258.213 442.942 229.115 C 281.098 204.371 175.306 150.05 -46.773 164.143 C -277.66 178.795 -174.154 -173.73 -50.195 -237.318 Z",
    style: {
      stroke: "url(#gradient-0)",
      paintOrder: "fill",
      strokeWidth: 0,
      fillRule: "nonzero",
      fill: "url(#gradient-2)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientBackground5);
export default __webpack_public_path__ + "static/media/gradient-background-5.9fd7fb7938b3e5afe4b7b3162104b5c9.svg";
export { ForwardRef as ReactComponent };